import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const USPWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: ${({ theme }) =>
    theme.colors.uspBackground || theme.colors.white};
  @media (min-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    visibility: ${({ $scrollDisable }) =>
      $scrollDisable ? "block" : "hidden"};
    transition: max-height 0.3s ease-in-out;
    max-height: ${({ $scrollDisable }) => ($scrollDisable ? "40px" : "0px")};
  }
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.uspBorderBottom || theme.colors.primary};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

const InnerWrapper = styled.div`
  max-width: 1920px;
  width: 100%;
  display: flex;
  .left {
    justify-content: flex-start;
    @media (max-width: 1920px) {
      margin: 0 0 0 1.7rem;
    }
  }
  .right {
    justify-content: flex-end;
    @media (max-width: 1920px) {
      margin: 0 1.7rem 0 0;
    }
  }
`;

const OuterDiv = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.colors.uspBackground || theme.colors.white};
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};

  p {
    padding: 0 0.6rem;
    margin: 0;
    font-size: 0.8rem;
    white-space: nowrap;
    width: auto;
    color: ${({ theme }) => theme.colors.uspText || theme.colors.black};
    a {
      color: ${({ theme }) => theme.colors.uspText || theme.colors.black};
    }
  }

  div {
    display: flex;
    align-items: center;
    padding: 0 0.6rem;
    font-size: 0.9rem;
    white-space: nowrap;
  }
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.uspText || theme.colors.black}

    &:hover {
      text-decoration: underline;
    }

    &:nth-child(2) {
      padding: 0 0.3rem;
    }
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin: 0 0.4rem 0 0;
  color: ${({ theme }) => theme.colors.uspIcon || theme.colors.black};
`;

const WithIcon = ({ icon, children }) =>
  icon && icon.json ? (
    <>
      <Icon icon={icon?.json ? JSON.parse(icon?.json) : null} />
      {children}
    </>
  ) : (
    children
  );

WithIcon.propTypes = {
  icon: PropTypes.object,
  children: PropTypes.node,
};

const WithURL = ({ url, children }) =>
  (url && url.length) > 0 ? (
    <a href={url} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  ) : (
    children
  );

WithURL.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
};

export default function USP({
  list,
  additional,
  paddingTop,
  paddingBottom,
  paddingRight,
  paddingLeft,
  scrollDisable,
}) {
  return (
    <>
      {(list?.length > 0 || additional?.length > 0) && (
        <USPWrapper
          $scrollDisable={scrollDisable}
          className={`active ${scrollDisable && "hidden"}`}
        >
          <InnerWrapper
            style={{
              paddingTop: `${parseInt(paddingTop) || 0}px`,
              paddingRight: `${parseInt(paddingRight) || 0}px`,
              paddingBottom: `${parseInt(paddingBottom) || 0}px`,
              paddingLeft: `${parseInt(paddingLeft) || 0}px`,
            }}
          >
            <OuterDiv className="left">
              {list?.map((item, index) => (
                <p key={index}>
                  <WithURL url={item?.url}>
                    <WithIcon icon={item?.icon}>{item?.text}</WithIcon>
                  </WithURL>
                </p>
              ))}
            </OuterDiv>
            <OuterDiv className="right">
              {additional?.map((item, index) => (
                <p key={index}>
                  <WithURL url={item?.url}>
                    <WithIcon icon={item?.icon}>{item?.text}</WithIcon>
                  </WithURL>
                </p>
              ))}
            </OuterDiv>
          </InnerWrapper>
        </USPWrapper>
      )}
    </>
  );
}

USP.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  additional: PropTypes.arrayOf(PropTypes.object),
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  paddingRight: PropTypes.string,
  paddingLeft: PropTypes.string,
  scrollDisable: PropTypes.bool,
};

USP.defaultProps = {
  list: [],
  additional: [],
};
